enum EnquiryStatus {
    Unknown = 0,
    New = 1,
    Processing = 2,
    Created = 3,
    Rejected = 4,
    Closed = 5,
    Held = 6
}

export { EnquiryStatus };